<template>
  <div id="app">
    <nav>
      <h1 class="logo">
        <img src="@/assets/images/logo/logo.jpg" >
      </h1>
      <router-link to="/">首页</router-link> 
      <router-link to="/train-cleaning">列车保洁</router-link> 
      <router-link to="/project-experience">项目经验</router-link> 
      <router-link to="/scientific-research">科研革新</router-link> 
      <router-link to="/news">新闻中心</router-link> 
      <router-link to="/corporate-culture">企业文化</router-link> 
      <router-link to="/about">关于我们</router-link> 
      <router-link to="/career">联系我们</router-link>
    </nav>
    <router-view></router-view>
    <!-- 在线客服 -->
    <!-- <div class="customer-service"> -->
      <button class="service-btn" @click="showCustomerService = !showCustomerService">
        <span>在</span>
        <span>线</span>
        <span>客</span>
        <span>服</span>
      </button>
      <div class="service-panel" :class="{ 'expanded': showCustomerService }">
        <p>客服热线</p>
        <p>电话：010-63967431</p>
        <p>服务时间：8:00-24:00</p>
      </div>
    <!-- </div> -->
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
// import News from './views/News.vue'
// import Career from './views/Career.vue'

export default {
  name: 'App',
  components: {
    Footer,
  },
  data() {
    return {
      showCustomerService: false
    };
  }
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
  margin-top: 0;
}
.logo img{
  /* font-size: 2em;
  font-weight: bold;
  color: #007bff; */
  /* margin: 20px 0; */
  width: 400px;
    height: 80px;
}
nav {
  width: 1715px;
  height: 100px;
  /* padding: 10px; */
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

nav a {
  /* width: 80px; */
  margin: 0 20px;
  text-decoration: none;
  color: #333;
  font-weight: 500;
  transition: color 0.3s ease;
}

nav a:hover {
  color: rgb(113, 204, 113);
}

nav a.router-link-active,
nav a.router-link-exact-active {
  /* color: #007bff; */
  /* font-weight: bold; */
}

.news-section {
  margin-top: 40px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.career-section {
  margin-top: 40px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.customer-service {
  position: fixed;
  right: 0px;
  bottom: 55%;
  transform: translateY(50%);
  z-index: 1000;
}

.service-btn {
  position: fixed;
  right: 0px;
  bottom: 55%;
  background: rgb(113, 204, 113);
  color: white;
  border: none;
  padding: 12px 16px 12px 8px; 
  /* border-radius: 24px 0 0 24px;  */
  cursor: pointer;
  transition: 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center; /* 文字居中 */
}

.service-btn:hover {
  background: rgb(83, 174, 83);
}

.service-panel {
    position: fixed;
    right: 35px;
    bottom: 50%;
    transform: translateY(50%);
    z-index: 1000;
    background: #f9f9f9;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
    padding: 24px;
    margin-top: 10px;
    min-width: 220px;
    visibility: hidden;
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    color: #444;
    line-height: 1.6;
}

.service-panel.expanded {
    visibility: visible;
    opacity: 1;
    transform: translateX(0);
    box-shadow: 0 6px 20px rgba(0,0,0,0.12);
}
</style>